import { Component, input } from '@angular/core';
import { IconKlankvoetNormal } from '../../icons/i-klankvoet-normal';
import { RidAlgorithmCard } from '../rid-algorithm-card/rid-algorithm-card';
import { RidCompressableKlankCard } from '../rid-compressable-klank-card/rid-compressable-klank-card';
import { RidKlankCard } from '../rid-klank-card/rid-klank-card';
import { RidSpacer } from '../rid-spacer/rid-spacer';
import { RidSyllabicCard } from '../rid-syllabic-card/rid-syllabic-card';
import { TKey } from '../rid-syllabic-keyboard/rid-syllabic-keyboard.utils';
import { RidSyllabicTextInput } from '../rid-syllabic-text-input/rid-syllabic-text-input';
import { RidVerticalSpacer } from '../rid-vertical-spacer/rid-vertical-spacer';

@Component({
  selector: 'rid-algorithm-normale-voet',
  imports: [
    RidSyllabicTextInput,
    RidVerticalSpacer,
    RidCompressableKlankCard,
    RidSyllabicCard,
    RidAlgorithmCard,
    IconKlankvoetNormal,
    RidSpacer,
    RidKlankCard,
  ],
  templateUrl: './rid-algorithm-normale-voet.html',
  host: {
    class: 'grid place-items-center',
  },
})
export class RidAlgorithmNormaleVoet {
  mode = input.required<'ICON' | 'AS_INPUT'>();
  voet = input.required<{ content: TKey[]; hasDubbelzetter: boolean; length: number; isLengthConfirmed: boolean }>();

  Array = Array;
}
